module.exports = __webpack_public_path__ + "static/02-dove-6f7e71da7e5202b750ca0ecae0e211a8.jpg";